import React from 'react';
import { JcSize, JcUtils } from '../utils/JcUtils';
import { JcBoxProps, JcRow } from './JcBox';
import { JcIcon, JcIconType } from './icon/JcIcon';
import { JcBuiltInIcon } from './icon/JcBuiltInIcons';

export interface JcInfoNoteProps extends Omit<JcBoxProps, "spacing" | "alignCenter" | "children"> {
  readonly text: string;
}

/**
 * A subtle help note prefixed with an info icon — for privacy/protection hints
 * and other supporting context beneath a form control. Muted, `sm`, and inline
 * (no box, unlike JcNotice).
 */
export const JcInfoNote: React.FunctionComponent<JcInfoNoteProps> = (props: JcInfoNoteProps) => {
  const boxProps = JcUtils.otherProps(props);
  const commonProps = JcUtils.commonProps(props, ["jc-info-note", "jc-note"]);

  return <JcRow {...commonProps} {...boxProps} spacing alignCenter>
    <JcIcon className="jc-info-note-icon" type={JcIconType.BUILT_IN} icon={JcBuiltInIcon.INFORMATION_CIRCLE} size={JcSize.EXTRA_SMALL} />
    {props.text}
  </JcRow>
}
